import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const RecordGroupsStateContext = createContext();

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  areOptionsLoaded: false
};

const RecordGroupsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <RecordGroupsStateContext.Provider value={stateHook}>
      {children}
    </RecordGroupsStateContext.Provider>
  );
};

export default RecordGroupsContextProvider;